import { TableCell, TableRow } from "@mui/material";

export function renderTotalRow(columns, totals, format = num => Number(num).toFixed(2)) {
  const firstNumericIndex = columns.findIndex(col => col.numeric);

  const currencyFormat = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });

  return (
    <TableRow>
      {columns.map((col, idx) => {
        if (idx === firstNumericIndex - 1) {
          return (
            <TableCell key="total-label" align="right">
              <strong>Total</strong>
            </TableCell>
          );
        }
        if (col.numeric) {
          const value = totals[col.key];
          const formatted = col.isMoney ? currencyFormat.format(value) : format(value);
          return (
            <TableCell key={`total-${col.key}`} align="right">
              <strong>{formatted}</strong>
            </TableCell>
          );
        }
        return <TableCell key={col.key} />;
      })}
    </TableRow>
  );
}
